module.exports = __webpack_public_path__ + "static/Group 133-00dc4b06e36a8b65b8bdf3921f8e3f6e.png";